import React, { useState } from 'react';
import ViewItems from '../../../components/ViewItems';
import Text from '../../../components/Text';
import { COLORS, fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { formatNumbers } from '../../../utils/utils';
import SarSymbol from '../../../components/SarSymbol';

const CardView = ({ title, amount, isSymbol }) => {
  const { TextWeight } = dynamicfunction();

  return (
    <ViewItems
      className={'border border-grey shadow rounded-xl px-5 py-5 w-full'}
    >
      <ViewReverse isReverse={false} >
        <Text
          text={title}
          size={fontSizes.h16}
          color={COLORS.black}
          weight={TextWeight.semiBold}
          isTruncate={false}
        />
        {isSymbol && <SarSymbol size={fontSizes.h16} />}
      </ViewReverse>

      <ViewReverse className={'items-center mt-4'} isReverse={false}>
        <Text
          color={COLORS.black}
          text={formatNumbers(amount)}
          size={fontSizes.h26}
          weight={TextWeight.medium}
        />
      </ViewReverse>
    </ViewItems>
  );
};

export default CardView;
